
/*===========================
  main-product
============================*/

/* reference_retail_price 3-digit separator */

  document.querySelectorAll('.price_value').forEach(function(el) {
    const raw = parseFloat(el.dataset.raw);
    if (!isNaN(raw)) {
      el.textContent = raw.toLocaleString('ja-JP', {
        style: 'currency',
        currency: 'JPY'
      });
    }
  });

/* condition_description accordion */

 document.addEventListener("DOMContentLoaded", function () {
   const jsonEl = document.getElementById("condition-data");
   if (!jsonEl) return;
   const rawJson = jsonEl.getAttribute("data-json");
   try {
     const data = JSON.parse(rawJson);

     if (Array.isArray(data) && data.length > 0) {
       const table = document.createElement("table");
       table.innerHTML = `
         <tbody>
           ${data.map(item => `
             <tr>
               <td>${item.label}</td>
               <td>${item.value}</td>
             </tr>
           `).join('')}
         </tbody>
       `;

       const pcContainer = document.querySelector(".condition-table--pc");
       if (pcContainer) {
         pcContainer.appendChild(table);
       }

       const spContainer = document.querySelector(".condition-table--sp");
       if (spContainer) {
         spContainer.appendChild(table.cloneNode(true));
       }
     }
   } catch (e) {
     console.error("JSON parse error:", e);
   }
 });

 
document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("size-actual-table-container");
  const rawJson = container.getAttribute("data-json");

  try {
    const data = JSON.parse(rawJson);

    if (Array.isArray(data) && data.length > 0) {
      const heading = document.createElement("p");
      heading.textContent = "実寸サイズ";
      heading.classList.add("size-heading");

      const table = document.createElement("table");
      table.innerHTML = `
        <tbody>
          ${data.map(item => `
            <tr>
              <td>${item.label}</td>
              <td>${item.value}</td>
            </tr>
          `).join('')}
        </tbody>
      `;
      container.appendChild(heading);
      container.appendChild(table);
    }
  } catch (e) {
    console.error("JSONパースエラー:", e);
  }
});
document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("size-official-table-container");
  const rawJson = container.getAttribute("data-json");

  try {
    const data = JSON.parse(rawJson);

    if (Array.isArray(data) && data.length > 0) {
      const heading = document.createElement("p");
      heading.textContent = "公式サイズ";
      heading.classList.add("size-heading");
      const note = document.createElement("p");
      note.textContent = "新品時の採寸情報を記載しているため、サイズ表記が多少異なる場合がございます。"
      note.classList.add("size-note");
      
      const table = document.createElement("table");
      table.innerHTML = `
      
        <tbody>
          ${data.map(item => `
            <tr>
              <td>${item.label}</td>
              <td>${item.value}</td>
            </tr>
          `).join('')}
        </tbody>
      `;


      container.appendChild(heading);
      container.appendChild(table);
      container.appendChild(note);
    }
  } catch (e) {
    console.error("JSONパースエラー:", e);
  }
});

/* comvey */
const shadowHost = document.querySelector('#comvey-root');
const shadowRoot = shadowHost.shadowRoot;
const heading = shadowRoot.querySelector('h3');
if (heading) {
  heading.style.fontSize = '1.2rem';
  heading.style.marginBottom = '8px';
}